<template>
  <div class="bb-accordion-content-cell"
       :class="[{'bb-accordion-content-cell_open': !isHidden},
       {'bb-accordion-content-cell_close': isHidden}]"
       :style="{height: !isHidden ? heightContent : 0}"
  >
    <transition name="slide">
      <div>
        <div v-for="description in descriptions"
             :key="description.paid"
             v-if="display"
             :class="{'bb-accordion-content-cell__text_hide': isHidden}"
             class="bb-accordion-content-cell__text"
        >
          <span>{{formatDate(description.date)}}</span>
          <span>{{description.description}}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
import moment from 'moment'
export default {
  name: 'AccordionContentCell',
  props: ['row', 'column', 'index'],
  computed: {
    descriptions () {
      return get(this.row, this.column.prop, [])
    },
    display () {
      return get(this.row, '$accordionContent', false)
    }
  },
  data () {
    return {
      heightContent: 'auto',
      isHidden: true
    }
  },
  methods: {
    setOpen () {
      this.isHidden = !this.display
    },
    calcHeight () {
      this.heightContent = 'auto'
      this.setOpen()
    },
    formatDate (date) {
      return moment(date).format('DD-MMM-YYY')
    }
  },
  watch: {
    display (newVal) {
      if (newVal) {
        this.$nextTick(this.calcHeight)
      } else {
        this.isHidden = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-accordion-content-cell {
    @include global-font;
    transition: 0.25s ease-out;
    margin-top: 18px;

    &_close {
      display: none;
    }

    &__text {
      padding: 20px 16px;
      border-radius: 4px;
      background-color: rgba($color-mercury, 0.35);
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;

      &_hide {
        opacity: 0;
        z-index: -1;
        pointer-events: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/AccordionCell/AccordionContentCell.vue